import { render, staticRenderFns } from "./addArticle.vue?vue&type=template&id=0f2b123b&scoped=true&"
import script from "./addArticle.vue?vue&type=script&lang=js&"
export * from "./addArticle.vue?vue&type=script&lang=js&"
import style0 from "./addArticle.vue?vue&type=style&index=0&id=0f2b123b&prod&lang=less&scoped=true&"
import style1 from "./addArticle.vue?vue&type=style&index=1&id=0f2b123b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b123b",
  null
  
)

export default component.exports